import styled, { css } from 'styled-components';
import { animationPresets } from '@styles/animations';

export const AnimatedElement = styled.div<{
  $animationType?: keyof typeof animationPresets;
  $delay?: number;
  $transformOrigin?: string;
  $width?: string;
}>`
  opacity: 0;
  ${({ $animationType = 'fadeIn', $delay = 0, $transformOrigin, $width }) => css`
    &.animate-in {
      ${animationPresets[$animationType]}
      animation-delay: ${$delay}s;
      transform-origin: ${$transformOrigin};
      width: ${$width};
    }
  `}
`;
